import {
  ListItemIcon,
  MenuItem,
  Select,
  styled,
  Typography,
  Box,
  Chip,
  IconButton,
} from '@mui/material';
import { palette } from 'view/themes/palette';

export const SelectedOptionsContainer = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    marginTop: '8px',
    cursor: 'default',
  };
});

export const SelectedOptionsImportanceContainer = styled(SelectedOptionsContainer)(({ theme }) => {
  return {
    gap: '2px',
  };
});

export const SelectedOption = styled(Chip)(({ theme }) => {
  return {
    cursor: 'default',
    width: 'max-content',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '4px',
    backgroundColor: palette.background.unknown,
    padding: '8px 16px',
    borderRadius: '32px',

    span: {
      fontSize: '12px',
      padding: '0',
      color: palette.text.header,
      fontWeight: 500,
      lineHeight: '16px',
    },

    button: {
      padding: '0',
      margin: '0!important',
    },
  };
});

export const SelectedImportanceOption = styled(SelectedOption)(({ theme }) => {
  return {
    width: '100%',
    height: 'max-content',
    backgroundColor: palette.background.blue500,
    padding: '16px 16px',
    borderRadius: '12px',

    '> span': {
      display: 'flex',
      alignItems: 'center',

      '.MuiRating-root': {
        display: 'flex',
        gap: '2px',

        '.MuiRating-pristine': {
          display: 'none',
        },

        '> label': {
          width: '10px',
          display: 'flex',
          justifyContent: 'center',

          '> span': {
            transform: 'scale(1)',
          },
        },
      },

      '.label': {
        fontSize: '16px',
        padding: '0',
        color: palette.text.header,
        fontWeight: 400,
        lineHeight: '22px',
        marginLeft: '8px',
      },
    },

    button: {
      padding: '0',
      margin: '0!important',
    },
  };
});

export const DeleteIcon = styled(IconButton)(({ theme }) => {
  return {
    color: theme.palette.grey[600],
    transition: 'color 0.2s',
    '&:hover': {
      color: theme.palette.error.main,
    },
    padding: theme.spacing(0.5),
  };
});

export const SelectLabel = styled(Typography)<{ error: string }>(({ error }) => {
  return {
    color: error ? palette.alerts.error : palette.text.header,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '128%',
    margin: '0 0 8px 0',
  };
});

export const ErrorMessage = styled(Typography)(({ theme }) => {
  return {
    color: palette.alerts.error,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    marginTop: '8px',
  };
}) as typeof Typography;

export const CustomSelect = styled(Select)<{ error: boolean }>(({ error }) => {
  return {
    width: '100%',
    color: palette.text.body,
    lineHeight: '136%',
    borderRadius: '8px',

    '&.MuiOutlinedInput-root': {
      borderRadius: '8px',
      minHeight: '40px',

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: error ? palette.alerts.error : palette.hover.brand,
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px',
        borderColor: palette.primary.purple500,
      },

      '&.Mui-error': {
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: palette.alerts.error,
        },
      },
    },

    '.MuiSelect-select': {
      height: '40px',
      padding: '8px 32px 8px 12px',
    },

    '.MuiMenu-paper': {
      borderRadius: '20px',
    },
  };
});

export const CustomMenuItem = styled(MenuItem)<{ isHide?: boolean }>(({ isHide }) => {
  return {
    color: palette.text.header,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '136%',
    padding: '8px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    gap: '4px',
    backgroundColor: 'transparent!important',

    span: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      /* width: '100%', */
    },

    '&.Mui-disabled': {
      display: isHide ? 'none' : 'flex',
      color: palette.text.header,
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '136%',
    },

    '&.Mui-selected': {
      color: palette.text.header,
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '136%',

      '&:hover': {
        backgroundColor: '#F4E8FF!important', // ✅ Фон меняется только при ховере
      },
    },

    '&:hover': {
      backgroundColor: '#F4E8FF!important', // ✅ Фон меняется только при ховере
    },
  };
});

export const Checkmark = styled(ListItemIcon)({
  minWidth: 'auto!important',
  color: '#3D1E66',

  '> svg': {
    width: '20px',
    height: '20px',
  },
});
